import { ERegionActionType } from './types';
import { prepareRegion } from '../../../../node/mappers/prepareRegion';
import { IRegion } from '../../../../node/types/region';
import { getTermsValue } from '../../../../packages/JsonQuery';
import { ResponseError } from '../../errors';
import { fetchGetRegion, TGetRegionResponse } from '../../repositories/monolith-python/v1/get-region';
import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';

const updateRegionRaw = actionGenerator<ERegionActionType.Changed, IRegion>(ERegionActionType.Changed);
export const resetRegion = actionGenerator<ERegionActionType.Changed>(ERegionActionType.Changed);

export function fetchRegion(): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    try {
      const {
        custom: { subdomain },
      } = context;
      const {
        filters: { jsonQuery },
      } = getState();
      const regionId = getTermsValue('region')(jsonQuery)?.[0];

      if (!regionId) {
        return;
      }

      const regionResponse: TGetRegionResponse = await fetchGetRegion({
        httpApi: context.httpApi,
        parameters: { regionId },
        config: {
          subdomain,
        },
      });

      if (regionResponse.statusCode !== 200) {
        throw new ResponseError({
          domain: 'resolveRegion',
          message: regionResponse.response.message,
          details: {
            regionId,
            error: regionResponse.response.errors,
          },
        });
      }

      const region = prepareRegion(regionResponse.response);

      if (!region) {
        return;
      }

      dispatch(updateRegionRaw(region));
    } catch (error) {
      const { logger } = context;

      logger.error(error);

      throw error;
    }
  };
}
